export default [
	{
		path: "/care/knowledgeEncyclopedias",
		component: resolve => require.ensure([], () => resolve(require("@/views/knowledgeEncyclopedias/knowledge-encyclopedias")), "knowledgeEncyclopedias"),
		meta: {
			title: "知识百科"
		}
	},
	{
		path: "/home/healthConsultation/healthCustomerService",
		component: resolve => require.ensure([], () => resolve(require("@/views/healthCustomerService/healthCustomerService")), "healthCustomerService"),
		meta: {
			title: "健康客服"
		}
	},
	// {
	// 	path: "/care/rotationchart",
	// 	component: resolve => require.ensure([], () => resolve(require("@/views/rotationChart/rotation-chart")), "rotationChart"),
	// 	meta: {
	// 		title: "健康客服"
	// 	}
	// }
]



// WEBPACK FOOTER //
// ./src/router/knowledgeEncyclopedias.js